var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { SimplePagination } from '@ui/SimplePagination';
import { PaginationDirection } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
function getScrollableElement(element) {
    if (!element) {
        return null;
    }
    if (element && element.scrollTop) {
        return element;
    }
    for (let i = 0; i < element.children.length; i++) {
        const child = element.children[i];
        const result = getScrollableElement(child);
        if (result) {
            return result;
        }
    }
    return null;
}
export const keyPaginationDefaultQueryParams = {
    count: 20,
    key: '',
    paginationDirection: PaginationDirection.Forward
};
export const keyPaginationFallbackQueryParams = {
    key: '',
    paginationDirection: PaginationDirection.Forward
};
export const KeyPagination = (_a) => {
    var _b;
    var { listRef, resource, onChange, showSizeChanger } = _a, rest = __rest(_a, ["listRef", "resource", "onChange", "showSizeChanger"]);
    const handlePaginationChange = useCallback((count, direction) => {
        if (direction) {
            onChange({
                count,
                key: direction === PaginationDirection.Forward ? resource === null || resource === void 0 ? void 0 : resource.nextKey : resource === null || resource === void 0 ? void 0 : resource.prevKey,
                paginationDirection: direction
            });
        }
        else {
            onChange({
                count,
                key: undefined,
                paginationDirection: PaginationDirection.Forward
            });
        }
        setTimeout(() => {
            var _a;
            if (listRef === null || listRef === void 0 ? void 0 : listRef.current) {
                const element = (_a = listRef.current.nativeElement) !== null && _a !== void 0 ? _a : listRef.current;
                const target = getScrollableElement(element);
                if (target) {
                    target.scrollTop = 0;
                }
            }
        }, 250);
    }, [listRef, resource === null || resource === void 0 ? void 0 : resource.nextKey, resource === null || resource === void 0 ? void 0 : resource.prevKey, onChange]);
    const results = (_b = resource === null || resource === void 0 ? void 0 : resource.results) !== null && _b !== void 0 ? _b : [];
    if (!results.length) {
        return null;
    }
    return (React.createElement(SimplePagination, Object.assign({}, rest, { enableNext: Boolean(resource === null || resource === void 0 ? void 0 : resource.nextKey), enablePrev: Boolean(resource === null || resource === void 0 ? void 0 : resource.prevKey), onChange: handlePaginationChange, showSizeChanger: showSizeChanger })));
};
